<script setup>
import { Button } from '@components'


import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

import RequirementItem from './RequirementItem.vue'
import Main from '../layout/Main.vue'
</script>

<template>
    <Main>
        <template #content>
            <div class="appointment-page-title">Requirements</div>

            <!-- requirements list -->
            <div class="flex flex-col gap-3">
                <RequirementItem v-for="(field, index) in $appointments.customFields" :key="index" :item="field" />
            </div>
        </template>

        <template #footer>
            <Button @click="$appointments.nextStep()" type="primary" size="md" radius="square" class="w-full">Continue</Button>
        </template>
    </Main>
</template>